import Vue from 'vue';
import VehicleLeasingCalculator from './vehicle-leasing-calculator/vehicle-leasing-calculator';
import CalculationEmail from './calculation-email/calculation-email.vue';
import CalculationEmailResult from './calculation-email-results/calculation-email-results.vue';
import calculatorEmailStore from './calculation-email/calculator-email-vuex';
import store from '../store';
if (!store.hasModule(['calculation-email'])) {
	store.registerModule('calculation-email', calculatorEmailStore);
}
Vue.component('vehicle-leasing-calculator', VehicleLeasingCalculator);
Vue.component('CalculationEmail', CalculationEmail);
Vue.component('CalculationEmailResult', CalculationEmailResult);
